/**
 * Pure error utility functions — no React, no client-only APIs.
 * Safe to import in both Server Components and Client Components.
 */

export interface ErrorProps {
  url?: string;
  method?: string;
  payload?: any;
  statusCode?: number;
  response?: any;
  message?: string;
  stackTrace?: string;
  errorId?: string;
}

/**
 * Extracts a structured error object from an Axios error.
 * Used in API catch blocks that run on both server and client.
 */
export const prepareErrorObj = (error: any) => {
  return {
    url: error.config?.url,
    method: error.config?.method,
    payload: error.config?.data,
    statusCode: error.response?.status ?? 500,
    response: error.response ? error.response.data : 'No response',
  };
};
